import cn from 'classnames';

/* Class assignment */
export const fullstudyformClass = (className) => cn(className, 'overflow-y-auto');
